import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import es from "../locales/es/translation.json";
import farmaOverridesEs from "../locales/es/farma.json";
import farmaOverridesEn from "../locales/en/farma.json";
import { deepMerge } from "../tenant/tenant";

// Texto por tipo de tenant como "lenguas" separadas:
//   · es      → base (clínica).
//   · esFarma → base + overrides de farma en español (locales/es/farma.json).
//   · enFarma → base + overrides de farma en inglés (locales/en/farma.json).
// Así un cambio de texto de farma vive solo en su farma.json y no toca a clínica.
// applyTenantLanguage() cambia la lengua activa según el tipo (reversible: basta
// con cambiar el mapeo de abajo para volver a esFarma sin perder ninguna traducción).
const esFarma = deepMerge(es, farmaOverridesEs);
const enFarma = deepMerge(es, farmaOverridesEn);

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            es: { translation: es },
            esFarma: { translation: esFarma },
            enFarma: { translation: enFarma },
        },
        fallbackLng: "es",
        supportedLngs: ["es", "esFarma", "enFarma"],
        interpolation: { escapeValue: false },
        // No cachear la lengua: la fija el tipo de tenant en cada sesión.
        detection: { caches: [] },
    });

/** Activa la variante de texto según el tipo de tenant. */
export function applyTenantLanguage(type) {
    i18n.changeLanguage(type === "farma" ? "enFarma" : "es");
}

export default i18n;
